import { makeObservable, observable, runInAction } from 'mobx';
import { BaseStore } from '../baseStore';
import { RootStore } from '../rootStore';
import { TransactionService } from '/src/api';
import { Transaction } from '/src/lib/models';
import { MenuItemType, TListTransactionsRequest } from '/src/lib/types';

export interface TransactionStoreProps {
  /**
   * List of Transactions
   */
  transactions?: Transaction[];
  /**
   * Transaction totals
   */
  totals?: Record<string, number>;
}

export class TransactionStore extends BaseStore implements TransactionStoreProps {
  private didInitMenu = false;
  transactions?: Transaction[];
  totals?: Record<string, number>;

  constructor(rootStore: RootStore) {
    super(rootStore);

    makeObservable(this, {
      transactions: observable,
      totals: observable,
    });
  }

  /**
   * Adds Transaction nav menu items to the app header.
   */
  initMenuItems = () => {
    if (this.didInitMenu || !this.rootStore.userStore.user) return;

    // Add menu items
    this.rootStore.menuStore.addMenuItem(
      'topbar',
      'Transactions',
      'transactions',
      MenuItemType.Item,
      '/transactions',
      false,
      undefined,
      1
    );

    runInAction(() => (this.didInitMenu = true));
  };

  /**** Data Processing ****/

  /**
   * Formats Transactions query response.
   *
   * @param transactions - An array of Transactions to format
   * @returns The formatted Transactions
   */
  formatQueryResponses = (transactions: Transaction[]) => {
    // Sort (newest items first)
    transactions.sort((a, b) => new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime());

    // Return
    return transactions;
  };

  /**** Transactions Services ****/

  /**
   * Fetches and saves Transactions ledger data.
   *
   * @param options - Required query options, including whether to retrieve Loan or Lender Transactions
   */
  query = async (options: TListTransactionsRequest) => {
    if (!options.loanId) return;

    const { transactions, totals } = await TransactionService.query(options);

    runInAction(() => {
      this.transactions = transactions;
      this.totals = totals;
    });
  };
}
